import React, { Component } from 'react';
import {Auth} from 'aws-amplify';
import AWS from 'aws-sdk';
import './iamExReport.css';
import IamExReTitleBar from './iamExReTitleBar/iamExReTitleBar.js';
import IamExReContent from './iamExReContent/iamExReContent.js';
import {readableDate} from '../../../universal/utils/index.js';

class IamExReport extends Component {

  state = {
    iamAuditUsers: [],
    updateDate: '...',
    iamAuditUpdateInProgress: false,
    accountFilter: 'All',
    userSort: [
      ['UserAccessLevel', -1],
      ['Account', 1],
      ['UserName', 1],
      ['LastAccess', 1]
    ]
  };

  componentDidMount() {

    setTimeout(() => {
      Auth.currentCredentials()
      .then(credentials => {
        this.S3 = new AWS.S3({credentials: Auth.essentialCredentials(credentials)});
        return this.downloadIamAudit();
      })
      .catch(err => {
        console.log(err);
      });
    }, 0);

  };

    downloadIamAudit = () => {

      return this.S3.getObject({Bucket: 'weaveability-basis-utilities-storage', Key: 'iamAudit/iamAudit.json', IfModifiedSince: new Date(2000)}).promise()
      .then(res => {
        const updateDate = readableDate(res.LastModified);
        this.setState({iamAuditUsers: JSON.parse(res.Body.toString()).Users, updateDate});
      });

    };

    refreshIamInformation = () => {

      let lambda;

      Auth.currentCredentials()
      .then(credentials => {
        lambda = new AWS.Lambda({credentials: Auth.essentialCredentials(credentials), region: 'eu-west-1'});
        this.setState({iamAuditUpdateInProgress: true});
        const alias = process.env.REACT_APP_STAGE === 'development' ? 'Dev' : 'Prod';
        return lambda.invoke({FunctionName: 'iam-audit-updater', Qualifier: alias}).promise();
      })
      .then(res => {
        this.setState({iamAuditUpdateInProgress: false});
        if (res.Payload === '"COMPLETE"') {
          return this.downloadIamAudit();
        }
      })
      .catch(err => {
        this.setState({iamAuditUpdateInProgress: false});
        console.log(err);
      });

    }

    render() {

      return (
        <div className="IamExReportPage">
          <IamExReTitleBar
            users={this.state.iamAuditUsers}
            updateDate={this.state.updateDate}
            refreshIamInformation={this.refreshIamInformation}
            iamAuditUpdateInProgress={this.state.iamAuditUpdateInProgress}
            accountFilter={this.state.accountFilter}
            updateFilter={this.updateFilter}
            updateUserSort={this.updateUserSort}
          />
          <IamExReContent
            users={this.state.iamAuditUsers.filter(this.usersFilter).sort(this.userSortFunction)}
            refreshIamInformation={this.refreshIamInformation}
          />
        </div>
      );

    };

    updateFilter = accountFilter => {
      this.setState({accountFilter});

    };

    usersFilter = user => {
      if (this.state.accountFilter === 'All') {
        return true;
      } else {
        return user.AccountId === this.state.accountFilter;
      }
    };

    updateUserSort = category => {

      const userSort = this.state.userSort.map(array => {
        return [...array];
      });

      if (userSort[0][0] === category) userSort[0][1] = userSort[0][1] * -1;
      else userSort.unshift(...userSort.splice(userSort.findIndex(sortArr => sortArr[0] === category), 1));

      this.setState({userSort});

    };

    userSortFunction = (a, b) => {

      const {userSort} = this.state;
      const newA = {
        UserName: a.UserName,
        Account: a.Account,
        UserAccessLevel: a.UserAccessLevel.userAccessLevel,
        LastAccess: a.LastAccess.accessDate
      };
      const newB = {
        UserName: b.UserName,
        Account: b.Account,
        UserAccessLevel: b.UserAccessLevel.userAccessLevel,
        LastAccess: b.LastAccess.accessDate
      };
      const sortFields = userSort.length;

      const recursiveSortFunction = index => {

        const sortA = typeof newA[userSort[index][0]] === 'string' ? newA[userSort[index][0]].toLowerCase() : newA[userSort[index][0]];
        const sortB = typeof newB[userSort[index][0]] === 'string' ? newB[userSort[index][0]].toLowerCase() : newB[userSort[index][0]];
        if (sortA === sortB) {
          if (index === sortFields - 1) return 0;
          else return recursiveSortFunction(index + 1);
        } else if ([sortA, sortB].sort()[0] === sortA) return userSort[index][1] * -1;
        else return userSort[index][1];

      };

      return recursiveSortFunction(0);

    };

};

export default IamExReport;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExReport/iamExReport.js